// removed by extract-text-webpack-plugin
module.exports = {"header":"localIdentName-about__header___nwCjv","description":"localIdentName-about__description___1HbBD","contribute":"localIdentName-about__contribute___13gkj"};


//////////////////
// WEBPACK FOOTER
// ./css/components/about.css
// module id = 1426
// module chunks = 0